module.exports = __webpack_public_path__ + "img/n_marudova.e5e12fb2.jpg";